import React, { useEffect, useState } from 'react'
import { postActualizarNotaQx, postPDFNotaQx } from '../../../../services/PaginaRuta'
import {PDFDownloadLink} from '@react-pdf/renderer'
import PDFNotaQx from './PDFNotaQx'


const ModalNotaAnestesiologo = ({setmodalONAnestesioLogo, dataAnestesiologo,user, passDataActualizarDescripcionQX}) => {
    const [loading, setLoading] = useState(true)
    const [dataProcedimientos, setDataProcedimientos] = useState([])
    const [textNota, setTextNota] = useState('')
    const [errorNota, setErrorNota] = useState('')
    const [botonGuardar, setBotonGuardar] = useState(false)
    const handleCancelarClick=()=>{
        setmodalONAnestesioLogo(false)
    }
    const handleOnclickGuardarNotaAnestesiologo=()=>{
      setLoading(false)
      setTimeout(() => {
          const updateNota={
            'ProCirCod' : dataAnestesiologo.ProCirCod,
            'PersCod' : dataAnestesiologo.PersCod,
            'nota' : textNota
        }
        postActualizarNotaQx(updateNota).then((res)=>{
          console.log(res.data,'res data actualizar nota')
          passDataActualizarDescripcionQX(updateNota)
          setmodalONAnestesioLogo(false)
          setLoading(true)
        })
    }, 500);
        
    }

    const handleOnchangeModificarNota=(e)=>{
      if(e.target.value.trim()!==''){
        setErrorNota('')
        setTextNota(e.target.value)
        setBotonGuardar(true)
      }else{
        setErrorNota('Escribir Nota Anestesiólogo')
        setTextNota(e.target.value)
        setBotonGuardar(false)
      }
    }

    useEffect(()=>{
      setTextNota(dataAnestesiologo.nota)
      setErrorNota(dataAnestesiologo.nota?'':'Escribir Nota Anestesiólogo')
      setBotonGuardar(dataAnestesiologo.nota?true:false)
      console.log(dataAnestesiologo.nota?true:false,' data anestesiologo')
      const dataPDF={
        'ProCirCod' : user.ProCirCod,
        'MCDpto' : user.ProMCDpto,
        'EMPCOD' : user.ProEmpCod,
        'ProEPS' : user.ProEPS,
      }
      setLoading(false)
      postPDFNotaQx(dataPDF).then((res)=>{
        setLoading(true)
        console.log(res.data,' dataPDF')
        setDataProcedimientos(res.data)
      })
    },[])
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%-3rem)] max-w-7xl  mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#9e56fe]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Nota Anestesiólogo
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div className="flex-auto overflow-y-auto relative p-1">
            
              <div className="flex py-2 text-left">
                <div className="w-1/3  px-4">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Nombre Paciente
                  </label>
                  <div className="flex">
                    <input
                      disabled={true}
                      defaultValue={user.MPNOMC}                      
                      type="text"
                      
                      autoComplete="off"
                      className="form-control block w-full px-1 py-1 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                </div>
                <div className="w-1/3  px-4">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Documento
                  </label>
                  <div className="flex">
                    <input
                      disabled={true}
                      defaultValue={user.MPCedu}                      
                      type="text"
                      
                      autoComplete="off"
                      className="form-control block w-full px-1 py-1 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                </div>
                <div className="w-1/3  px-4">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Quirofano
                  </label>
                  <div className="flex">
                    <input
                      disabled={true}
                      defaultValue={user.ProNcons}                      
                      type="text"
                      
                      autoComplete="off"
                      className="form-control block w-full px-1 py-1 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                </div>
                
              </div>
              <div className="flex py-2 text-left">
                <div className="w-1/3  px-4">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Nombre Anestesiólogo
                  </label>
                  <div className="flex">
                    <input
                      disabled={true}
                      defaultValue={dataAnestesiologo.MMNomM}                      
                      type="text"
                      
                      autoComplete="off"
                      className="form-control block w-full px-1 py-1 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                </div>
                <div className="w-1/3  px-4">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Especialidad 
                  </label>
                  <div className="flex">
                    <input
                      disabled={true}
                      defaultValue={dataAnestesiologo.MENomE}                      
                      type="text"
                      
                      autoComplete="off"
                      className="form-control block w-full px-1 py-1 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                </div>
                <div className="w-1/3  px-4">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Numero Cirugía
                  </label>
                  <div className="flex">
                    <input
                      disabled={true}
                      defaultValue={dataAnestesiologo.ProCirCod}                      
                      type="text"
                      
                      autoComplete="off"
                      className="form-control block w-full px-1 py-1 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                </div>
                
              </div>
            <div className="px-2 pt-2">
              <textarea
                onChange={handleOnchangeModificarNota}
                value={textNota}
                className="form-control block w-full px-3 py-1.5 text-base font-normal  text-gray-700  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300 rounded
                        transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                id="exampleFormControlTextarea1"
                rows="8"
                placeholder=""
              ></textarea>
              <div className='text-left'>
              <label className="form-label inline-block mb-2 text-red-900 text-sm font-medium">
                      {errorNota}
                    </label>
                    </div>
            </div>
          </div>

          <div className="flex justify-between items-center p-2 border-t border-gray-200 rounded-b-md">
          <div>
         
          </div>
          <div className="text-right ">
         
            
            <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Cerrar
            </button>
            {
              botonGuardar?
              <PDFDownloadLink document={<PDFNotaQx dataProcedimientos={dataProcedimientos} user={user} dataAnestesiologo={dataAnestesiologo} textNota={textNota}/>} fileName='pdfffffffffffffffffffffffff.pdf'>
                <button
                  //type="button"
                  onClick={handleOnclickGuardarNotaAnestesiologo}
                  className="inline-block mx-2 px-4 py-1.5 bg-[#9e56fe] text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out "
                >
                  Guardar
                </button>
                </PDFDownloadLink>
                :
                <button
                  //type="button"
                  //onClick={handleOnclickGuardarNotaAnestesiologo}
                  className="inline-block mx-2 px-4 py-1.5 bg-[#9e56fe] text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out "
                >
                  Guardar
                </button>
                
            }
            
            </div>
          </div>
        </div>
      </div>
      {
                              loading?
                              null:
                              <div className="relative flex items-center justify-center h-screen">
            <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-slate-900 bg-opacity-25" style={{ pointerEvents: "auto" }}>
                <div className="flex flex-col items-center justify-center p-6 bg-white rounded shadow-lg">
                    <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
                    <p className="mt-4 text-lg">Cargando</p>
                </div>
            </div>
            <div className="absolute top-0 left-0 w-full h-full" style={{ pointerEvents: "none" }}></div>
        </div>
                            }
      
    </div>
  )
}

export default ModalNotaAnestesiologo